<!--
TODO  autofocus inline edit fields
      save on enter
      add info: amount of users, news and docs connected
      
-->

<template>
  <div class="establishments">
    <page-title title="Vestigingen" description="Vestigingen beheer"></page-title>

    <div class="row ml-2 mr-2">
      <div class="col">
        <h5>aantal vestigingen: {{establishments.length}}</h5>
      </div>
      <div class=""><button type="button" class="btn btn-success" @click="addNew">+ nieuwe vestiging</button></div>
    </div>

    <div
      class="card float-left m-3"
      style="width: 21rem; height: 30rem"
      v-for="est in establishments"
      :key="est.id"
    >
    <div>
     
      <div class="img_container">
        <img class="card-img-top" v-bind:src="est.image.url" alt="bedrijfsfoto" v-if="est.image" />
      
      <img
        class="card-img-top"
        src="https://via.placeholder.com/300x200?text=geen+foto"
        alt="bedrijfsfoto"
        v-if="!est.image"
      /></div>
      <div class="card-body">
         <button title="verwijder deze vestiging"  class="btn float-right  btn-sm ml-2 btn-danger" @click="deleteEstablishment(est)"><svg class="bi bi-trash" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
  <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
</svg></button>
        <button title="maak dit de hoofdvestiging" class="btn float-right btn-light btn-sm" v-if="!est.hq || est.hq==false" @click="setHQ(est)"><svg class="bi bi-building" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" d="M15.285.089A.5.5 0 0 1 15.5.5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .418-.493l5.582-.93V3.5a.5.5 0 0 1 .324-.468l8-3a.5.5 0 0 1 .46.057zM7.5 3.846V8.5a.5.5 0 0 1-.418.493l-5.582.93V15h8v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.222l-7 2.624z"/>
  <path fill-rule="evenodd" d="M6.5 15.5v-7h1v7h-1z"/>
  <path d="M2.5 11h1v1h-1v-1zm2 0h1v1h-1v-1zm-2 2h1v1h-1v-1zm2 0h1v1h-1v-1zm6-10h1v1h-1V3zm2 0h1v1h-1V3zm-4 2h1v1h-1V5zm2 0h1v1h-1V5zm2 0h1v1h-1V5zm-2 2h1v1h-1V7zm2 0h1v1h-1V7zm-4 0h1v1h-1V7zm0 2h1v1h-1V9zm2 0h1v1h-1V9zm2 0h1v1h-1V9zm-4 2h1v1h-1v-1zm2 0h1v1h-1v-1zm2 0h1v1h-1v-1z"/>
</svg></button><button title="Dit is de hoofdvestiging" class="btn float-right btn-primary btn-sm" v-if="est.hq" ><svg class="bi bi-building" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" d="M15.285.089A.5.5 0 0 1 15.5.5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .418-.493l5.582-.93V3.5a.5.5 0 0 1 .324-.468l8-3a.5.5 0 0 1 .46.057zM7.5 3.846V8.5a.5.5 0 0 1-.418.493l-5.582.93V15h8v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.222l-7 2.624z"/>
  <path fill-rule="evenodd" d="M6.5 15.5v-7h1v7h-1z"/>
  <path d="M2.5 11h1v1h-1v-1zm2 0h1v1h-1v-1zm-2 2h1v1h-1v-1zm2 0h1v1h-1v-1zm6-10h1v1h-1V3zm2 0h1v1h-1V3zm-4 2h1v1h-1V5zm2 0h1v1h-1V5zm2 0h1v1h-1V5zm-2 2h1v1h-1V7zm2 0h1v1h-1V7zm-4 0h1v1h-1V7zm0 2h1v1h-1V9zm2 0h1v1h-1V9zm2 0h1v1h-1V9zm-4 2h1v1h-1v-1zm2 0h1v1h-1v-1zm2 0h1v1h-1v-1z"/>
</svg></button>
       
        <Storage class="float-right mr-2"
          path="establishments/"
          v-on:setUrl="((url)=> setUrl(url, est))"
          v-on:setFilename="setFilename"
          imageOnly
          noPreview
          icon
        ></Storage>

        <table class="table table-borderless table-sm">
          <tr >
            <th colspan="2" class="card-title editable" @click="est.editing.name=true">
        <input type="text" v-model="est.name" v-if="est.editing.name" @blur="update(est, 'name')" />
        <span v-if="!est.editing.name">{{est.name}}</span>
      </th>
          </tr>
          <tr>
            <td class="label">adres</td>
            <td class="editable" @click="est.editing.address=true">
              <input
                type="text"
                v-model="est.address"
                v-if="est.editing.address"
                @blur="update(est, 'address')"
              />
              <span v-if="!est.editing.address">{{est.address}}</span>
            </td>
          </tr>
          <tr>
            <td class="label">postcode</td>
            <td class="editable" @click="est.editing.zipcode=true">
              <input
                type="text"
                v-model="est.zipcode"
                v-if="est.editing.zipcode"
                @blur="update(est, 'zipcode')"
              />
              <span v-if="!est.editing.zipcode">{{est.zipcode}}</span>
            </td>
          </tr>
          <tr>
            <td class="label">plaats</td>
            <td class="editable" @click="est.editing.city=true">
              <input
                type="text"
                v-model="est.city"
                v-if="est.editing.city"
                @blur="update(est, 'city')"
              />
              <span v-if="!est.editing.city">{{est.city}}</span>
            </td>
          </tr>
          <tr>
            <td class="label">tel.nr.</td>
            <td class="editable" @click="est.editing.phonenumber=true">
              <input
                type="text"
                v-model="est.phonenumber"
                v-if="est.editing.phonenumber"
                @blur="update(est, 'phonenumber')"
              />
              <span v-if="!est.editing.phonenumber">{{est.phonenumber}}</span>
            </td>
          </tr>
        </table>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import PageTitle from "@/components/PageTitle.vue";
//import Spinner from "@/components/Spinner.vue";
import Storage from "@/components/Storage.vue";
//var firestorage = fb.firestorage;

import { mapState } from "vuex";
var firestorage = fb.firestorage;

export default {
  name: "Establishments",
  components: {
    PageTitle,
    //Spinner
    Storage
  },
  computed: {
    ...mapState(["currentUser", "userProfile"])
  },
  data() {
    return {
      company: {
        name: "",
        zipcode: "",
        city: ""
      },
      establishments: [],
      env: "loading",
      downloadURL: "",
      fileName: "",
      editBools:  {
              name: false,
              address: false,
              zipcode: false,
              city: false,
              phonenumber: false
            },
    };
  },
  methods: {
    update(est, what) {
      var object = {};
      switch (what) {
        case "name":
          est.editing.name = false;
          if (est.name != undefined) object = { name: est.name };
          break;
        case "address":
          est.editing.address = false;
          if (est.address != undefined) object = { address: est.address };
          break;
        case "zipcode":
          est.editing.zipcode = false;
          if (est.zipcode != undefined) object = { zipcode: est.zipcode };
          break;
        case "city":
          est.editing.city = false;
          if (est.city != undefined) object = { city: est.city };
          break;
        case "phonenumber":
          est.editing.phonenumber = false;
          if (est.phonenumber != undefined)
            object = { phonenumber: est.phonenumber };
          break;
      }

      if (object == {}) return;
      fb.companiesCollection
        .doc(this.$cookies.get("company"))
        .collection("establishments")
        .doc(est.id)
        .update(object);
    },
    setHQ(est) {
      if (confirm("Deze vestiging als hoofdvestiging instellen?")) {
        this.establishments.forEach(e => {
          if (e.hq && e.hq == true) {
            e.hq=false;
            fb.companiesCollection
              .doc(this.$cookies.get("company"))
              .collection("establishments")
              .doc(e.id)
              .update({
                hq: false
              });
          }
        });
        est.hq = true;
        fb.companiesCollection
          .doc(this.$cookies.get("company"))
          .collection("establishments")
          .doc(est.id)
          .update({
            hq: true
          });
      }
    },
    addNew(){
      var newname = prompt("Wat is de naam van de vestiging?")
      if (!newname) return false;

      var newEstablishment = {

            address:"klik om aan te passen",
            city: "",
            phonenumber: "",
            zipcode: "",
            name: newname,
            hq: false,
            image: {
              url: "https://via.placeholder.com/300x200?text=Upload+een+foto",
              filename: ""
            },

      }
      var t = this;
      // loading TODO
      fb.companiesCollection
        .doc(this.$cookies.get("company"))
        .collection("establishments")
        .add(
          newEstablishment
        ).then(function(docRef){
          console.log(docRef.id)
          // stop loading spinner          
          newEstablishment.id = docRef.id
          newEstablishment.editing = t.editBools
          t.establishments.push(newEstablishment)
        })
    },
    deleteEstablishment(est){
       if (!confirm("Deze vestiging verwijderen?")) return false
      var t = this
      fb.companiesCollection
        .doc(this.$cookies.get("company"))
        .collection("establishments")
        .doc(est.id)
        .delete().then(function(){
          for(var i = 0; i < t.establishments.length;i++){
            if (t.establishments[i].id == est.id){
              t.establishments.splice(i,1)
            }
          }
        })
    },
    setUrl(url, est) {
      this.downloadURL = url;
      this.deleteImage(est);
      fb.companiesCollection
        .doc(this.$cookies.get("company"))
        .collection("establishments")
        .doc(est.id)
        .update({
          image: {
            url: this.downloadURL,
            filename: this.fileName
          }
        });
      est.image.url = url;
      est.image.filename = this.fileName;
    },
    setFilename(fn) {
      this.fileName = fn;
    },
    deleteImage(est) {
      if (est.image.filename == "") return;
      firestorage
        .ref(
          "establishments/" +
            this.$cookies.get("company") +
            "/" +
            est.image.filename
        )
        .delete()
        .then(() => {
          console.log("oude image verwijderd");
        })
        .catch(error => {
          console.error(`file delete error occured: ${error}`);
        });
    }
  },
  created() {
    this.env = fb.env;
    fb.companiesCollection
      .doc(this.$cookies.get("company"))
      .collection("establishments")
      .orderBy('name')
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            id: doc.id,
            address: doc.data().address,
            city: doc.data().city,
            phonenumber: doc.data().phonenumber,
            zipcode: doc.data().zipcode,
            name: doc.data().name,
            hq: doc.data().hq,
            image: {
              url: doc.data().image
                ? doc.data().image["url"]
                : "https://via.placeholder.com/300x200?text=Upload+een+foto",
              filename: doc.data().image ? doc.data().image["filename"] : ""
            },
            editing: this.editBools
          };
          this.establishments.push(data);
        });
      });
  }
};
</script>

<style scoped>
.img_container {
  width: 100%;
  height: 202px;
  overflow: hidden;
  border: 1px solid #ddd;
}
.img_container:hover {
  width: 100%;
  height: 202px;
  overflow: auto;
  border: 1px solid #ddd;
}
.label {
  font-size: 14px;
  font-style: italic;
}
.editable:hover {
  cursor: cell;
  background-color: gainsboro;
}
.dummy {
  background: #ffffff;
  height: 100%;
  text-align: center;
   padding: 170px 0;
}
.bi-plus-square:hover {
  fill: darkgray;
  cursor: pointer;
}
</style>